import {uploads} from "@/mixins/uploads";

export default {

    name(tenant){
        return tenant?.name;
    },

    theme_logo(tenant, options = {w: 100, h:100, c: false}){
        if( !tenant?.meta?.logo?.url ) return '/images/dfc-logo.svg';
        return uploads.image( tenant.meta.logo.url, options );
    },

    theme_background(tenant, options = {w: 1800, h:1800, c: false}){
        if( !tenant?.meta?.theme?.background?.url ) return null;
        return uploads.image( tenant.meta.theme.background.url,  options);
    }

}
